<template>
	<div class="limiter">
		<div class="container-login100">
			<div class="wrap-login100">
				<div class="login100-pic js-tilt" data-tilt>
					<img src="/static/img/Blue-Yeti.png" alt="IMG">
				</div>
				<div class="login100-form validate-form">
					<span class="login100-form-title">
						<img src="https://pub.automatad.com/static/img/apl-h.png">
					</span>
					<div class="error-msg">
						<p>{{error}}</p>
					</div>
					<div class="wrap-input100 validate-input" data-validate = "Password is required">
						<input class="input100" v-validate="'required|min:6'" data-vv-delay="5000" :class="{'input': true, 'is-danger': errors.has('password') }" name="password" type="password" placeholder="Password" v-model="credentials.password1" v-on:keyup.enter="submit()">
						<span class="focus-input100"></span>
						<span class="symbol-input100">
							<i class="fa fa-lock" aria-hidden="true"></i>
						</span>
					</div>
					<div class="wrap-input100 validate-input" data-validate = "Password is required">
						<input class="input100" v-validate="'required|min:6'" data-vv-delay="5000" :class="{'input': true, 'is-danger': errors.has('password') }" name="password" type="password" placeholder="Password" v-model="credentials.password2" v-on:keyup.enter="submit()">
						<span class="focus-input100"></span>
						<span class="symbol-input100">
							<i class="fa fa-lock" aria-hidden="true"></i>
						</span>
					</div>
					<div class="container-login100-form-btn">
						<button class="login100-form-btn" type="submit" @click="submit()" :disabled="!formValid">Reset Password</button>
					</div>
					<div class="text-center p-t-12">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue'
	import VeeValidate from 'vee-validate'
	Vue.use(VeeValidate)
	import axios from 'axios';
	export default {
		data () {
			return {
				credentials: {
					password1: '',
					password2: ''
				},
				error: '',
			}
		},
		methods: {
			submit () {
				axios.post(BASE_URL + 'v1/auth/password/reset/confirm/', {
				  uid: this.$route.params.id,
				  token: this.$route.params.resetID,
		          new_password1: this.credentials.password1,
		          new_password2: this.credentials.password2
		        })
		  
		        .then(response => {
		            this.$notify({
		              title: 'Success',
		              message: 'Password has been changed successfully.',
		              type: 'success'
		            });

		            setTimeout(() => { this.$router.push('/login/'); }, 1500);
		        })
		        .catch(error => {
		      		this.$notify({
		              title: 'Warning',
		              message: 'Password has not been changed, please check if the passwords entered are same.',
		              type: 'warning'
		            });
		        })
			}
		},
		computed: {
			formValid(){
				if(this.credentials.password2 &&  (this.credentials.password1!= this.credentials.password2)){
					this.error = "Error, the two passwords do not match."
				}else{
					this.error = ""
				}
				return this.credentials.password1 == this.credentials.password2;
			}
		}
	}
</script>
<style scoped>
	.extra-span{
		top: -38px;
	}
	.back-login{
		margin:10px;
	}
	.textAlign{
		text-align: right;
	}
	.error-msg{
		padding-left: 30px;
	}
</style>
<style>
	#app {
		/*background: white !important;*/
		height: 100% !important;
	}
	.backgroundImage{
		background-image: url("http://keenthemes.com/metronic/preview/assets/app/media/img//bg/bg-4.jpg");
		background-attachment: fixed;
		background-size: cover;
		height: 800px;
	}
	.background-color-login{
		background-color: white;
		padding-top: 0px !important;
	}
	.login-logo{
		text-align: center;
		margin: 60px;
	}
	/* -- body styles ------------------------------------- */
	/* -- button styles ------------------------------------- */
	/*-- signin-card animation ---------------------------------------- */
	.signin-card {
		-webkit-animation: cardEnter 0.75s ease-in-out 0.5s;
		animation: cardEnter 0.75s ease-in-out 0.5s;
		-webkit-animation-fill-mode: both;
		animation-fill-mode: both;
		opacity: 0;
	}
	/* -- login paper styles ------------------------------ */
	.signin-card {
		max-width: 350px;
		border-radius: 2px;
		margin: 20px auto;
		padding: 20px;
		box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
	}
	.signin-card .logo-image,
	.signin-card h1,
	.signin-card p {
		text-align: center;
	}
	/* -- font styles ------------------------------------- */
	.display1 {
		font-size: 28px;
		font-weight: 100;
		line-height: 1.2;
		color: #757575;
		text-transform: inherit;
		letter-spacing: inherit;
	}
	.subhead {
		font-size: 16px;
		font-weight: 300;
		line-height: 1.1;
		color: #212121;
		text-transform: inherit;
		letter-spacing: inherit;
	}
	/* card animation from Animate.css -------------------- */
	@-webkit-keyframes cardEnter {
		0%,
		20%,
		40%,
		60%,
		80%,
		100% {
			-webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		0% {
			opacity: 0;
			-webkit-transform: scale3d(0.3, 0.3, 0.3);
			-ms-transform: scale3d(0.3, 0.3, 0.3);
			transform: scale3d(0.3, 0.3, 0.3);
		}
		20% {
			-webkit-transform: scale3d(1.1, 1.1, 1.1);
			-ms-transform: scale3d(1.1, 1.1, 1.1);
			transform: scale3d(1.1, 1.1, 1.1);
		}
		40% {
			-webkit-transform: scale3d(0.9, 0.9, 0.9);
			-ms-transform: scale3d(0.9, 0.9, 0.9);
			transform: scale3d(0.9, 0.9, 0.9);
		}
		60% {
			opacity: 1;
			-webkit-transform: scale3d(1.03, 1.03, 1.03);
			-ms-transform: scale3d(1.03, 1.03, 1.03);
			transform: scale3d(1.03, 1.03, 1.03);
		}
		80% {
			-webkit-transform: scale3d(0.97, 0.97, 0.97);
			-ms-transform: scale3d(0.97, 0.97, 0.97);
			transform: scale3d(0.97, 0.97, 0.97);
		}
		100% {
			opacity: 1;
			-webkit-transform: scale3d(1, 1, 1);
			-ms-transform: scale3d(1, 1, 1);
			transform: scale3d(1, 1, 1);
		}
	}
	@keyframes cardEnter {
		0%,
		20%,
		40%,
		60%,
		80%,
		100% {
			-webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		0% {
			opacity: 0;
			-webkit-transform: scale3d(0.3, 0.3, 0.3);
			-ms-transform: scale3d(0.3, 0.3, 0.3);
			transform: scale3d(0.3, 0.3, 0.3);
		}
		20% {
			-webkit-transform: scale3d(1.1, 1.1, 1.1);
			-ms-transform: scale3d(1.1, 1.1, 1.1);
			transform: scale3d(1.1, 1.1, 1.1);
		}
		40% {
			-webkit-transform: scale3d(0.9, 0.9, 0.9);
			-ms-transform: scale3d(0.9, 0.9, 0.9);
			transform: scale3d(0.9, 0.9, 0.9);
		}
		60% {
			opacity: 1;
			-webkit-transform: scale3d(1.03, 1.03, 1.03);
			-ms-transform: scale3d(1.03, 1.03, 1.03);
			transform: scale3d(1.03, 1.03, 1.03);
		}
		80% {
			-webkit-transform: scale3d(0.97, 0.97, 0.97);
			-ms-transform: scale3d(0.97, 0.97, 0.97);
			transform: scale3d(0.97, 0.97, 0.97);
		}
		100% {
			opacity: 1;
			-webkit-transform: scale3d(1, 1, 1);
			-ms-transform: scale3d(1, 1, 1);
			transform: scale3d(1, 1, 1);
		}
	}
button[disabled=disabled], button:disabled {
	background-color: rgba(200,200,200,2.3);
	cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// ResetPassword.vue?76e0306d